import DefaultHeading from '../../components/heading/DefaultHeading';
import { Loader } from '../../components/loader/Loader'
import TableData from '../../components/brandDashboard/tableData';
import { getBannerData } from './brandDashboardService';
import './brandDashboard.css';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'

function BrandDashboard() {

    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<Record<string, any>[]>([]);

    const columns: GridColDef[] = [
        { field: 'brand', headerName: 'Brand Name', width: 150, flex: 1, editable: false, headerAlign: 'center', align: 'left' },
        { field: 'totalSku', headerName: 'Total no of SKUS', width: 170, flex: 1, editable: false, headerAlign: 'center', align: 'center' },
        { field: 'totalImage', headerName: 'Total SKUs with images tagged', width: 170, flex: 1, editable: false, headerAlign: 'center', align: 'center' },
        { field: 'imageTagPerc', headerName: '% Image tagged (total)', width: 170, flex: 1, editable: false, headerAlign: 'center', align: 'center' },
        { field: 'sohSku', headerName: 'Total no.of SKUS with SOH', width: 170, flex: 1, editable: false, headerAlign: 'center', align: 'center' },
        { field: 'sohImg', headerName: 'Image tagged (basis SOH)', width: 170, flex: 1, editable: false, headerAlign: 'center', align: 'center' },
        { field: 'sohPerc', headerName: '% Image tagged (basis SOH)', width: 170, flex: 1, editable: false, headerAlign: 'center', align: 'center' },
    ];

    const getData = async () => {
        setLoading(true);
        try {
            const response: Record<string, any>[] = await getBannerData();
            setData(response);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className='brand-dashboard-wrapper'>
            {
                loading ? <Loader /> : <div className="brand-dashboard-header">
                    <DefaultHeading heading='Brand Dashboard' showDefaultBackButton />
                    <TableData
                        data={data}
                        columns={columns}
                    />
                </div>
            }
        </div>
    )
}

export default BrandDashboard